import clsx from 'clsx'
import type { HTMLAttributes } from 'react'

import styles from './Spinner.module.scss'

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 's' | 'm' | 'l'
}

export function Spinner({ className, size = 'm', ...props }: SpinnerProps) {
  const sizeMap = {
    s: '16px',
    m: '24px',
    l: '40px',
  } as const

  return (
    <div
      {...props}
      className={clsx(styles.spinner, className)}
      style={{ width: sizeMap[size], height: sizeMap[size], ...props.style }}
      aria-label="Loading"
      role="status"
    />
  )
}
